import React from "react";
import { InferGetServerSidePropsType } from "next";
import { PageLevelEvents } from "@/components/PageLevelEvents/PageLevelEvents";
import {
  getServerSideProps,
  PageProps,
} from "@/getServerSideProps/getServerSideProps";
import ErrorPage from "@/components/Error/ErrorPage";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { layoutMap } from "@/layouts/layoutMap";
import { Default, Meta } from "..";
import { Debugger } from "@/components/Debugger/Debugger";

export { getServerSideProps } from "@/getServerSideProps/getServerSideProps";

export default function ErrorWrappedPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  if (props.type === "error") return <ErrorPage />;
  if (props.type !== "success") return null;
  return <Page {...props} />;
}

function Page(props: PageProps) {
  const { product, pageConfig, flags } = props;

  const { variant, isSelected } = useVariant(product);

  const Layout = layoutMap[pageConfig.layout] || Default;

  return (
    <>
      <Meta product={product} flags={flags} />
      <Layout {...props} />
      <PageLevelEvents
        product={product}
        variant={variant}
        pageConfig={pageConfig}
        flags={flags}
        isSelected={isSelected}
      />
      <Debugger {...props} />
    </>
  );
}
